<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisModal from 'dashboard/components-next/LaisModal.vue';
import VisitConfirmationPanel from './VisitConfirmationPanel.vue';
import VisitConfirmationSuccess from './VisitConfirmationSuccess.vue';

defineProps({
  show: { type: Boolean, default: false },
  success: { type: Boolean, default: false },
  visit: { type: Object, default: null },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['close', 'action', 'confirm', 'editEntry']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisModal
    :show="show"
    title="Confirmar visita"
    max-width-class="max-w-[620px]"
    @close="emit('close')"
  >
    <VisitConfirmationSuccess v-if="success" @action="emit('action')" />
    <VisitConfirmationPanel
      v-else
      :visit="visit"
      :loading="loading"
      @confirm="emit('confirm')"
      @edit-entry="emit('editEntry')"
    />
  </LaisModal>
</template>
